import { useState } from 'react';
import { motion } from 'framer-motion';
import { solutionsAffairesData } from '../data/solutionsAffairesData';
import AikupCard from '../components/AikupCard';
import AikupModal from '../components/AikupModal';
import ExpertVisionModal from '../components/ExpertVisionModal';
import CadreReferentielNISTModal from '../components/CadreReferentielNISTModal';
import CyberOpsModal from '../components/CyberOpsModal';
import Microsoft365SecuriteModal from '../components/Microsoft365SecuriteModal';
import Loi25Modal from '../components/Loi25Modal';
import PriseEnChargeSolutionsAffairesModal from '../components/PriseEnChargeSolutionsAffairesModal';
import EvaluationPostureModal from '../components/EvaluationPostureModal';
import GouvernanceSolutionsAffairesModal from '../components/GouvernanceSolutionsAffairesModal';
import FormationSolutionsAffairesModal from '../components/FormationSolutionsAffairesModal';
import GestionRapportsCyberModal from '../components/GestionRapportsCyberModal';
import UsecurePhishingCampaignsModal from '../components/UsecurePhishingCampaignsModal';
import MaesterMicrosoft365Modal from '../components/MaesterMicrosoft365Modal';
import AIInsightBubble from '../components/AIInsightBubble';
import Header from '../layout/Header';
import LeadersSection from '../components/LeadersSection';
import type { SolutionsAffairesItem } from '../data/solutionsAffairesData';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CyberAdvisorDashboardModal from '../components/CyberAdvisorDashboardModal';
import VulnerabilityScanReportsModal from '../components/VulnerabilityScanReportsModal';
import UsecurePhishingCampaignReportsModal from '../components/UsecurePhishingCampaignReportsModal';

export default function SolutionsAffairesCybersecurite() {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState<SolutionsAffairesItem | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expertVisionModal, setExpertVisionModal] = useState<{
    isOpen: boolean;
    expert: 'dany' | 'yannick' | 'francois' | null;
    item: SolutionsAffairesItem | null;
  }>({
    isOpen: false,
    expert: null,
    item: null,
  });
  const [isNISTOpen, setIsNISTOpen] = useState(false);
  const [isCyberOpsOpen, setIsCyberOpsOpen] = useState(false);
  const [isMicrosoft365Open, setIsMicrosoft365Open] = useState(false);
  const [isLoi25Open, setIsLoi25Open] = useState(false);
  const [isPriseEnChargeOpen, setIsPriseEnChargeOpen] = useState(false);
  const [isEvaluationPostureOpen, setIsEvaluationPostureOpen] = useState(false);
  const [isGouvernanceOpen, setIsGouvernanceOpen] = useState(false);
  const [isFormationOpen, setIsFormationOpen] = useState(false);
  const [isGestionRapportsCyberOpen, setIsGestionRapportsCyberOpen] = useState(false);
  const [isUsecureCampaignsOpen, setIsUsecureCampaignsOpen] = useState(false);
  const [isMaesterOpen, setIsMaesterOpen] = useState(false);
  const [isCyberAdvisorDashboardOpen, setIsCyberAdvisorDashboardOpen] = useState(false);
  const [isVulnerabilityScanReportsOpen, setIsVulnerabilityScanReportsOpen] = useState(false);
  const [isUsecurePhishingReportsOpen, setIsUsecurePhishingReportsOpen] = useState(false);

  const handleCardClick = (item: SolutionsAffairesItem) => {
    if (item.id === 1) {
      // Cadre Référentiel NIST 2.0
      setIsNISTOpen(true);
    } else if (item.id === 2) {
      // CyberOps
      setIsCyberOpsOpen(true);
    } else if (item.id === 3) {
      // Microsoft 365 & Office 365
      setIsMicrosoft365Open(true);
    } else if (item.id === 4) {
      // Loi 25
      setIsLoi25Open(true);
    } else if (item.id === 5) {
      // Prise en Charge
      setIsPriseEnChargeOpen(true);
    } else if (item.id === 6) {
      // Évaluation de Posture
      setIsEvaluationPostureOpen(true);
    } else if (item.id === 11) {
      // Analyses Maester Microsoft 365
      setIsMaesterOpen(true);
    } else if (item.id === 7) {
      // Gouvernance Cybersécurité
      setIsGouvernanceOpen(true);
    } else if (item.id === 8) {
      // Formation & Sensibilisation
      setIsFormationOpen(true);
    } else if (item.id === 10) {
      // uSecure - automatisation des suivis mensuels (formations, uPhish, uBreach; uPolicy exclu)
      setIsUsecureCampaignsOpen(true);
    } else if (item.id === 9) {
      // Gestion des rapports cyber
      setIsGestionRapportsCyberOpen(true);
    } else if (item.id === 12) {
      // Tableau de bord conseiller
      setIsCyberAdvisorDashboardOpen(true);
    } else if (item.id === 13) {
      // Rapports de balayage de vulnérabilités
      setIsVulnerabilityScanReportsOpen(true);
    } else if (item.id === 14) {
      // Rapports de campagnes d’hameçonnage uSecure
      setIsUsecurePhishingReportsOpen(true);
    } else {
      setSelectedItem(item);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedItem(null), 300);
  };

  const leaders = [
    {
      name: "Stéphane Paradis",
      title: "Directeur intérimaire Solutions d'affaires & Cybersécurité",
      avatar: "/SP.png",
      vision: "Stéphane apporte une approche structurée, collaborative et orientée résultats pour accompagner l'équipe et les clients vers des solutions d'affaires sécuritaires et durables.",
      attentes: "Stéphane s'attend à ce que PRIsME clarifie les priorités, les responsabilités et les suivis afin de livrer une expérience client cohérente, professionnelle et mesurable.",
      pagePRIsME: "La page PRIsME de Cybersécurité regroupe le cadre NIST 2.0, CyberOps, Microsoft 365, la Loi 25 et les outils de prise en charge nécessaires pour inspirer confiance."
    },
    {
      name: "Mikael Drouin-Bouchard",
      title: "Spécialiste en cybersécurité",
      avatar: "/MDB.png",
      vision: "Mikael met l’accent sur la rigueur et la cohérence: transformer les besoins en solutions, avec des contrôles sécurité pragmatiques et une exécution stable.",
      attentes: "Mikael s'attend à ce que PRIsME standardise nos façons de faire (cadres, modèles, validations) et améliore la qualité des livrables SA/Cyber. Son objectif : rendre la démarche plus simple à répéter, plus fiable et plus mesurable.",
      pagePRIsME: "La page PRIsME de Solutions d’affaires est notre point de convergence pour la méthode: gouvernance, référentiels, outils et documentation — pour livrer vite, bien et de façon sécuritaire."
    },
    {
      name: "Philippe Bolduc",
      title: "Spécialiste en cybersécurité",
      avatar: "/PB.png",
      vision: "Philippe apporte une vision terrain, structurée et orientée résultats pour aligner les besoins d’affaires avec des solutions concrètes, tout en maintenant une posture de sécurité solide.",
      attentes: "Philippe s'attend à ce que PRIsME accélère l'analyse, la priorisation et l'exécution des demandes SA, avec des livrables clairs, traçables et sécuritaires. Son objectif : réduire le flou, augmenter la qualité et livrer plus vite.",
      pagePRIsME: "La page PRIsME de Solutions d’affaires consolide la gouvernance, les cadres et les outils internes pour cadrer les besoins, documenter les décisions et livrer des solutions alignées et sécurisées."
    }
  ];

  const cyberLeaders = [
    { name: 'Stéphane', avatar: '/SP.png', title: "Directeur intérimaire Solutions d'affaires & Cybersécurité" },
    { name: 'Mikael', avatar: '/MDB.png', title: 'Spécialiste en cybersécurité' },
    { name: 'Philippe', avatar: '/PB.png', title: 'Spécialiste en cybersécurité' },
  ];

  // Organiser par catégorie
  const categories = Array.from(new Set(solutionsAffairesData.map(item => item.category)));

  return (
    <div className="flex-1 w-full max-w-none min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Header 
        title="Cybersécurité"
        subtitle="Cadre NIST, posture, conformité, gouvernance et services cybersécurité BZ Inc. regroupés dans une sous-section dédiée de Solutions d’affaires."
      />
      
      <div className="w-full max-w-none px-6 py-6 xl:px-8 2xl:px-10">
        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <button
            type="button"
            onClick={() => navigate('/solutions-affaires')}
            className="inline-flex w-fit items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm hover:border-blue-300 hover:text-blue-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour à Solutions d’affaires
          </button>
        </div>

        <div className="w-full max-w-none mb-8">
          <LeadersSection leaders={leaders} title="Nos Leaders - Cybersécurité" />
        </div>


        <div className="w-full max-w-none mb-10">
          <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 mb-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500"
            >
              <p className="text-sm text-gray-600 mb-1">Outils Disponibles</p>
              <p className="text-3xl font-bold text-gray-900">{solutionsAffairesData.length}</p>
              <p className="text-xs text-gray-500 mt-1">Frameworks sécurité</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500"
            >
              <p className="text-sm text-gray-600 mb-1">Score Maturité</p>
              <p className="text-3xl font-bold text-gray-900">
                {Math.round(solutionsAffairesData.reduce((sum, item) => sum + (item.kpiScore || 0), 0) / solutionsAffairesData.length)}%
              </p>
              <p className="text-xs text-gray-500 mt-1">Moyenne excellence</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-xl shadow-md p-6 border-l-4 border-blue-500"
            >
              <p className="text-sm text-gray-600 mb-1">Catégories</p>
              <p className="text-3xl font-bold text-gray-900">{categories.length}</p>
              <p className="text-xs text-gray-500 mt-1">Domaines couverts</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="bg-white rounded-xl shadow-md p-6 border-l-4 border-red-500"
            >
              <p className="text-sm text-gray-600 mb-1">Conformité</p>
              <p className="text-3xl font-bold text-gray-900">
                {solutionsAffairesData.filter(item => item.category === 'Conformité' || item.category === 'Cadre Référentiel').length}
              </p>
              <p className="text-xs text-gray-500 mt-1">Outils conformité</p>
            </motion.div>
          </div>

          <div className="w-full max-w-none rounded-3xl border border-purple-200 bg-white/80 backdrop-blur-sm p-6 md:p-8 shadow-md">
            <div className="space-y-8">
              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Framework</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Framework').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Outil Interne</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Outil Interne').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Plateforme</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Plateforme').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Conformité</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Conformité').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Service</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Service').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Diagnostic</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Diagnostic').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Gouvernance</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Gouvernance').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center mb-5">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 text-center">Formation et sensibilisation</h3>
                </div>
                <div className="w-full max-w-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
                  {solutionsAffairesData.filter((item) => item.category === 'Formation').map((item, idx) => (
                    <div key={item.id} className="w-full max-w-none">
                      <AikupCard
                        item={item as any}
                        onClick={() => handleCardClick(item)}
                        onExpertClick={(expert: 'dany' | 'yannick' | 'francois') => {
                          setExpertVisionModal({ isOpen: true, expert, item });
                        }}
                        customLeaders={cyberLeaders}
                        hideCategoryBadge
                        hideAIBadge
                        index={idx}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <CyberAdvisorDashboardModal
        isOpen={isCyberAdvisorDashboardOpen}
        onClose={() => setIsCyberAdvisorDashboardOpen(false)}
        onOpenUsecure={() => setIsUsecureCampaignsOpen(true)}
        onOpenOffers={() => navigate('/solutions-affaires/offres-de-cybersecurite')}
      />

      <VulnerabilityScanReportsModal
        isOpen={isVulnerabilityScanReportsOpen}
        onClose={() => setIsVulnerabilityScanReportsOpen(false)}
      />

      <UsecurePhishingCampaignReportsModal
        isOpen={isUsecurePhishingReportsOpen}
        onClose={() => setIsUsecurePhishingReportsOpen(false)}
      />

      <AikupModal
        item={selectedItem as any}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />

      <CadreReferentielNISTModal
        isOpen={isNISTOpen}
        onClose={() => setIsNISTOpen(false)}
      />

      <CyberOpsModal
        isOpen={isCyberOpsOpen}
        onClose={() => setIsCyberOpsOpen(false)}
      />

      <Microsoft365SecuriteModal
        isOpen={isMicrosoft365Open}
        onClose={() => setIsMicrosoft365Open(false)}
      />

      <Loi25Modal
        isOpen={isLoi25Open}
        onClose={() => setIsLoi25Open(false)}
      />

      <PriseEnChargeSolutionsAffairesModal
        isOpen={isPriseEnChargeOpen}
        onClose={() => setIsPriseEnChargeOpen(false)}
      />

      <EvaluationPostureModal
        isOpen={isEvaluationPostureOpen}
        onClose={() => setIsEvaluationPostureOpen(false)}
      />

      <GouvernanceSolutionsAffairesModal
        isOpen={isGouvernanceOpen}
        onClose={() => setIsGouvernanceOpen(false)}
      />

      <FormationSolutionsAffairesModal
        isOpen={isFormationOpen}
        onClose={() => setIsFormationOpen(false)}
      />

      <GestionRapportsCyberModal
        isOpen={isGestionRapportsCyberOpen}
        onClose={() => setIsGestionRapportsCyberOpen(false)}
      />

      <UsecurePhishingCampaignsModal
        isOpen={isUsecureCampaignsOpen}
        onClose={() => setIsUsecureCampaignsOpen(false)}
      />

      <MaesterMicrosoft365Modal
        isOpen={isMaesterOpen}
        onClose={() => setIsMaesterOpen(false)}
      />

      <ExpertVisionModal
        isOpen={expertVisionModal.isOpen}
        onClose={() => setExpertVisionModal({ isOpen: false, expert: null, item: null })}
        expert={expertVisionModal.expert}
        item={expertVisionModal.item}
      />

      <AIInsightBubble />
    </div>
  );
}
